import React from 'react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

import NormalButton from './NormalButton';
import RootStore from '../../store/RootStore';
import { checkCurrentGalleryNeedPay, isWeb } from '../../utils/util';

interface IDownloadButton {
  rootStore?: RootStore;
}
function DownloadButton(props: IDownloadButton) {
  const name = intl.get('Download-Pendent');
  const { galleryStore, wxuserStore } = props.rootStore!;
  const showBottom = function () {
    //  如果是模拟用户, 那么就需要先授权
    if (wxuserStore.user.is_mock && Number(window.configDetail.active_on) == 1) {
      wxuserStore.auth();
      return false;
    }

    const visibleEvent = new Event('PENDENT_FOLD');
    visibleEvent.data = 1;
    window.dispatchEvent(visibleEvent);
    galleryStore.setJigsaw({
      type: 'download',
      bottomShow: true,
    });
  };
  const { list } = galleryStore;
  if (!list || !list.length) {
    // 无相册图片的页面不需要显示下载按钮
    // console.log('当前相册页没有照片(或者暂时还没获取到)，不显示下载按钮');
    return null;
  }
  // 已登录的微信用户，并且 微信手机端才显示下载按钮
  // 目前发现微信PC端的小程序按钮无法显示，所以这里对这种情况不显示
  if (
    (window.isweixin && !window.isweixinweb) ||
    isWeb()
    // || process.env.NODE_ENV === 'development'
  ) {
    if (checkCurrentGalleryNeedPay()) {
      //  如果当前相册需要付费，不显示下载按钮, 后续逻辑更简洁
      return null;
    }
    return <NormalButton onClick={showBottom}>{name}</NormalButton>;
  }
  return null;
}
export default inject('rootStore')(observer(DownloadButton));
